import { removeBasketProductTiles, resetHeightOnTiles, syncHeightCarouselTiles, loadLazyImages } from "../utilities/globalUtilities";
import { productRecommendations, productRecommendationsLarge } from "../utilities/carouselSlickConfig";
import { pushProductClick, pushProductImpression } from "../dataLayer/utils";
import { initEvents } from "../utilities/globalEvents";
import { CHECKOUT_RECOMMENDATION_LIST, MAX_CAROUSEL_TILES  } from "../utilities/constants";
import { triggerInitWishlistTogglers } from "../wishlist/wishlist";

/**
 * @function
 * @description - Recommendations page recommendations carousel initialization
 * @param {Object} $container - Container to search for carousel
 * @param {Boolean} shouldRemoveBasketProductTiles - Flag to remove basket product tiles
 */
const initializeCarouselWithConfig = (carouselSelector, $container = $(document), shouldRemoveBasketProductTiles = true) => {
    $container.find(carouselSelector).each(function () {
        const $this = $(this);
        const brandID = $this.data("brandid");
        const tilesNumber = $this.data("tiles-number");
        const carouselTypeConfig = $this.closest(".carousel-large").length ? productRecommendationsLarge(tilesNumber, brandID) : productRecommendations(tilesNumber, brandID);

        if (shouldRemoveBasketProductTiles) {
            removeBasketProductTiles($this);
        }

        const tilesDisplayedNumber = $this.find(".product-tile").length;
        if (tilesDisplayedNumber) {
            syncHeightCarouselTiles($this);

            const $carousels = $this.not(".slick-initialized");
            
            $carousels.parent().parent().find(".js-productcarousel-skeleton").addClass("d-none");
            $carousels.parent().find(".js-productcarousel-skeleton").addClass("d-none");
            $carousels.find(".js-productcarousel-skeleton").addClass("d-none");
            
            $this.slick(carouselTypeConfig);
        }

        if ($this.attr("data-active-tiles-number")) {
            $this.on("beforeChange", loadNextProductTiles);
        }

        setTimeout(() => {
            initEvents();
        }, 100);
    });
};

const loadNextProductTiles = (event, slick, currentSlide, nextSlide) => {
    const carousel = $(event.target);
    const totalTiles = parseInt(carousel.attr("data-tiles-number"), 10); 
    const activeTilesNumber = parseInt(carousel.attr("data-active-tiles-number"), 10);
    if (totalTiles == activeTilesNumber) {
        return;
    }
    if ((slick.slideCount - nextSlide) < MAX_CAROUSEL_TILES) {
        nextSlide -= (MAX_CAROUSEL_TILES - (slick.slideCount - nextSlide));
    }

    carousel.spinner().start();

    let tiles = [];
    for (let i = 1; i <= MAX_CAROUSEL_TILES; i++) {
        let slickTile = carousel.find(".pd-tile--not-loaded-"+(nextSlide+i)+":not(.slick-cloned)");
        if (slickTile && slickTile.length > 0) {
            initProductTile(slickTile);
            slickTile.removeClass("pd-tile--not-loaded pd-tile--not-loaded-"+(nextSlide+i));
            slickTile.removeAttr("data-url");
            tiles.push(slickTile[0]);
        }
    }

    if (tiles.length > 0) {
        setupProductImpression(tiles);
        resetHeightOnTiles(carousel);
        syncHeightCarouselTiles(carousel);
        carousel.addClass("lazyload-tiles");
        loadLazyImages(`.${carousel[0].className.replaceAll(" ", ".")}`);
        carousel.removeClass("lazyload-tiles");
        carousel.attr("data-active-tiles-number", activeTilesNumber+tiles.length);
    }

    carousel.spinner().stop();
};

const initProductTile = (tile) => {
    $.ajax({
        url: tile.attr("data-url"),
        type: "get",
        async: false,
        success: response => {
            if (response) {
                tile.html(response, setTimeout(() => triggerInitWishlistTogglers(), 50));
            }
        }
    });
};

const setupProductImpression = (tiles) => {
    const productsImpression = tiles.map(item => {
        if (item.classList.contains("slick-cloned") || !item.classList.contains("pd-tile--not-loaded")) {
            return null;
        }

        const idx = item?.dataset?.idx;
        const productTileImpression = JSON.parse(item.querySelector(".ct-product-tile").dataset?.productTileImpression);
        const listName = item.closest(".product-grid-recommendations-wrapper")?.querySelector(".ct-recommendations--carousel-title")?.innerText.trim() || CHECKOUT_RECOMMENDATION_LIST;

        const checkoutRecommendationProductImpression = Object.assign({}, productTileImpression, {
            "list": listName,
            "position": idx
        });

        const clickImpression = Object.assign({}, productTileImpression, {
            "position": idx
        });

        const descriptionElement = item.querySelector(".pwc-tile--description");
        if (descriptionElement) {
            descriptionElement.addEventListener("click", () => {
                pushProductClick([clickImpression], listName);
            });
        }

        const tileImageElement = item.querySelector(".ct-tile-image");
        if (tileImageElement) {
            tileImageElement.addEventListener("click", () => {
                pushProductClick([clickImpression], listName);
            });
        }

        return checkoutRecommendationProductImpression;
    }).filter(item => {

        return !!item;
    });

    pushProductImpression(productsImpression);
};

const initRecommendationsCarousels = ($container, shouldRemoveBasketProductTiles) => {
    initializeCarouselWithConfig(".recommendations-products-carousel", $container, shouldRemoveBasketProductTiles);
};

const initRecommendationsCarouselsSponsored = ($container, shouldRemoveBasketProductTiles) => {
    initializeCarouselWithConfig(".recommendations-products-carousel-sponsored", $container, shouldRemoveBasketProductTiles);
};

/**
 * @function
 * @description - listens to the lazyLoadTemplate:loaded and triggers events for carousel slick & lazy load product images
 */
const initBrandsRecommendationsCarousels = () => {
    $(".js-brands-recommendations-section.js-lazyload-template").on("lazyLoadTemplate:loaded", (_event, $data) => {
        initRecommendationsCarousels($data, false);
        $data.each(function () { this.className && loadLazyImages(`.${this.className.replace(" ", ".")}`); });
    });
};

export { initRecommendationsCarousels, initBrandsRecommendationsCarousels, initRecommendationsCarouselsSponsored };
